import { SORT_DIRECTIONS } from "./tableConstants";

/**
 * Toggles sort direction: null -> "desc" -> "asc" -> "desc" -> ...
 */
export const getNextSortDirection = (currentDirection) => {
  if (!currentDirection) return SORT_DIRECTIONS.DESC;
  return currentDirection === SORT_DIRECTIONS.DESC
    ? SORT_DIRECTIONS.ASC
    : SORT_DIRECTIONS.DESC;
};

/**
 * Slices data array for client-side pagination.
 * currentPage is 1-based.
 */
export const getPaginatedData = (data, currentPage, pageSize) => {
  if (!data || !Array.isArray(data)) return [];
  const start = (currentPage - 1) * pageSize;
  return data.slice(start, start + pageSize);
};

/**
 * Calculates total number of pages.
 */
export const getTotalPages = (totalItems, pageSize) => {
  if (!totalItems || !pageSize || pageSize <= 0) return 0;
  return Math.ceil(totalItems / pageSize);
};

/**
 * Generates array of page numbers with ellipsis markers for pagination UI.
 * Returns numbers and "..." strings.
 * Pattern: first, last, current + neighbors, ellipsis between gaps.
 */
export const generatePageNumbers = (currentPage, totalPages) => {
  if (totalPages <= 0) return [];
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const pages = new Set();
  pages.add(1);
  pages.add(totalPages);
  pages.add(currentPage);
  if (currentPage > 1) pages.add(currentPage - 1);
  if (currentPage < totalPages) pages.add(currentPage + 1);

  const sorted = [...pages].sort((a, b) => a - b);
  const result = [];

  for (let i = 0; i < sorted.length; i++) {
    if (i > 0 && sorted[i] - sorted[i - 1] > 1) {
      result.push("...");
    }
    result.push(sorted[i]);
  }

  return result;
};

/**
 * Access nested object values via dot-path string.
 * Example: getNestedValue({ a: { b: 1 } }, "a.b") => 1
 */
export const getNestedValue = (obj, path) => {
  if (!obj || !path) return undefined;
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
};
